import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor() { }


  getFullUrl(urlEndPoint: string) {
    return environment.baseUrl + urlEndPoint;
  }

 encryptUsingAES256(originalValue: any) {
  const sec_key = localStorage.getItem('sec_key');
  if (!sec_key) {
    throw new Error('Encryption key not found in localStorage');
  }

  const decoded_secret = atob(sec_key);
  const _key = CryptoJS.enc.Utf8.parse(decoded_secret);

  const encrypted = CryptoJS.AES.encrypt(
    JSON.stringify(originalValue),
    _key,
    {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }
  );

  return encrypted.toString(); // Base64 encoded ciphertext
}

  decryptUsingAES256(encryptedValue: string) {
    const sec_key = localStorage.getItem('sec_key');
    if (!sec_key) {
      throw new Error('key not found');
    }

    const decoded_secret = atob(sec_key);
    const _key = CryptoJS.enc.Utf8.parse(decoded_secret);

    try {
      const decrypted = CryptoJS.AES.decrypt(encryptedValue, _key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });

      const decryptedValue = decrypted.toString(CryptoJS.enc.Utf8);
      return JSON.parse(decryptedValue);

    } catch (err) {
      console.error('Decryption failed or invalid JSON:', err);
      throw err;
    }
  }

  fileToBase64(fileToUpload: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result as string); // This is a base64 data URL string
      };
      reader.onerror = error => {
        reject(error);
      };
      reader.readAsDataURL(fileToUpload);
    });
  }
  fileToBase64Old(fileToUpload: any) {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (function (theFile) {
        return function (e: any) {
          let binaryData = e.target.result;
          let base64String = window.btoa(binaryData);
          resolve(base64String);
        };
      })(fileToUpload);
      reader.readAsBinaryString(fileToUpload);
    });
  }


}
